import React from 'react';
import { Input, Select, Tooltip, Button } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import { graphql, compose } from 'react-apollo';
const FormItem = Form.Item;
const Option = Select.Option;

import getUsuario from '../../../../graphql/querys/auth/getUsuario.graphql';

@compose(graphql(getUsuario))
class FormBuscar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);

        this.props.onSubmit(values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  onReiniciar = () => {
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const prefixDocumento = getFieldDecorator('tipo_doc', {
      initialValue:
        this.props.persona && this.props.persona.tipo_doc
          ? this.props.persona.tipo_doc
          : undefined,
      defaultValue:
        this.props.persona && this.props.persona.tipo_doc
          ? this.props.persona.tipo_doc
          : undefined,
      rules: [{ message: 'Por favor, ingresar el tipo de documento!' }],
    })(
      <Select style={{ width: 70 }}>
        <Option value="DNI">DNI</Option>
        <Option value="CI">CI</Option>
        <Option value="LC">LC</Option>
        <Option value="LE">LE</Option>
      </Select>
    );
    const generoSelector = getFieldDecorator('genero', {
    })(
      <Select placeholder ="Genero" style={{ width: 150 }}>
        <Option value="F">F - Femenino</Option>
        <Option value="M">M - Masculino</Option>
        <Option value="X">X - No Binario</Option>
      </Select>
    );

    return (
      <div>
        <h1 className="tituloForm">Parametros de Busqueda</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Documento
                <Tooltip title="Tipo y Numero de documento">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('num_doc', {
              rules: [
                {
                  message:
                    'Por favor, ingresar el documento de forma correcta, sin puntos!',
                  validator: this.checkNumDoc,
                },
              ],
            })(<Input addonBefore={prefixDocumento}  addonAfter={generoSelector} style={{ width: 500 }} />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Nombre
                <Tooltip title="Nombre de la persona">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('nombre', {
              rules: [
                {
                  message: 'Por favor, ingresar el nombre!',
                  whitespace: true,
                },
              ],
            })(<Input style={{ width: 500 }} />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Apellido
                <Tooltip title="Apellido de la persona">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('apellido', {
              rules: [
                {
                  message: 'Por favor, ingresar el apellido!',
                  whitespace: true,
                },
              ],
            })(<Input style={{ width: 500 }} />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Estado del Contraventor
                <Tooltip title="Estado del contraventor">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('estado', {
              rules: [
                {
                  message: 'Por favor, ingresar el estado!',
                  whitespace: true,
                },
              ],
            })(
              <Select style={{ width: 500 }}>
                <Option value="PRESUNTO CONTRAVENTOR">
                  PRESUNTO CONTRAVENTOR
                </Option>
                <Option value="SANCIONADO">SANCIONADO</Option>
                <Option value="ABSUELTO">ABSUELTO</Option>
                <Option value="DESESTIMADO">DESESTIMADO</Option>
              </Select>
            )}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button
              type="danger"
              onClick={this.onReiniciar}
              disabled={this.props.loading}
            >
              Reiniciar Filtros
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              disabled={this.props.loading}
              type="primary"
              htmlType="submit"
            >
              Buscar Expedientes
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    return {
      tipo_doc: Form.createFormField({
        value: props.tipo_doc ? props.tipo_doc : undefined,
      }),
      num_doc: Form.createFormField({
        value: props.num_doc ? props.num_doc : undefined,
      }),
      nombre: Form.createFormField({
        value: props.nombre ? props.nombre : undefined,
      }),
      apellido: Form.createFormField({
        value: props.apellido ? props.apellido : undefined,
      }),
      estado: Form.createFormField({
        value: props.estado ? props.estado : undefined,
      }),
    };
  },
})(FormBuscar);
